import { Challenge, ChallengeType } from '../interfaces'

export enum NetherlandsPilotChallenge {
  CheersToTheDutch = 'CheersToTheDutch',
  PublicDanceDare = 'PublicDanceDare',
  WindmillWonder = 'WindmillWonder',
  SilentTrain = 'SilentTrain',
  TheLettersToUtrecht = 'TheLettersToUtrecht',
  StreetArtHunt = 'StreetArtHunt',
  LocalFlavor = 'LocalFlavor', // +
  ComplimentALocal = 'ComplimentALocal',
  BullishAdventure = 'BullishAdventure',
  InternationalCourt = 'InternationalCourt',
  WindmillSpin = 'WindmillSpin',
  DomTowerSnapshot = 'DomTowerSnapshot',
  ProvincesShowdown = 'ProvincesShowdown',
  FindMiffy = 'FindMiffy',
  PublicKaraoke = 'PublicKaraoke',
  JapaneseChristmas = 'JapaneseChristmas',
  ProgrammingBirthplace = 'ProgrammingBirthplace',
  RepurposedHistory = 'RepurposedHistory',
  Grachtenhuis = 'Grachtenhuis',
  DutchMasters = 'DutchMasters',
  TwoCitiesOneName = 'TwoCitiesOneName',
  GlassWalk = 'GlassWalk',
  WoodenShoes = 'WoodenShoes',
  VOCHeritage = 'VOCHeritage',
  InsuranceLandmark = 'InsuranceLandmark',
  StatueSelfie = 'StatueSelfie',
  BinnenhofBeauty = 'BinnenhofBeauty',
  MarketBrowsing = 'MarketBrowsing',
  StatuePose = 'StatuePose',
  Photobomb = 'Photobomb',
  GuessTheJob = 'GuessTheJob',
  DutchChat = 'DutchChat',
  Paparazzi = 'Paparazzi',
  RoyalConnection = 'RoyalConnection',
  PetsAreTheBest = 'PetsAreTheBest',
  CityOfBikes = 'CityOfBikes',
  AlphabetCity = 'AlphabetCity',
}

export const NetherlandsPilotChallenges: Record<NetherlandsPilotChallenge, Challenge> = {
  [NetherlandsPilotChallenge.CheersToTheDutch]: {
    key: NetherlandsPilotChallenge.CheersToTheDutch,
    type: ChallengeType.Normal,
    points: 10,
    challenge: {
      en: 'Cheers to the Dutch',
      nl: 'Proost op de Nederlanders',
      pt: 'Saúde aos Holandeses',
      zh: '为荷兰人干杯',
      ro: 'Noroc olandezilor',
      fr: 'Santé aux Néerlandais',
    },
    description: {
      en: 'Try a local Dutch beverage.',
      nl: 'Probeer een lokaal Nederlands drankje.',
      pt: 'Experimente uma bebida holandesa local.',
      zh: '尝试当地荷兰饮料。',
      ro: 'Încearcă o băutură locală olandeză.',
      fr: 'Essayez une boisson locale néerlandaise.',
    },
    image:
      'https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExeWUxZm5udjMycTBhd3dwZ2FsNnNlNjMxajdsZGRhbXl6eGNuZTVzYSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/BPJmthQ3YRwD6QqcVD/giphy.webp',
  },
  [NetherlandsPilotChallenge.PublicDanceDare]: {
    key: NetherlandsPilotChallenge.PublicDanceDare,
    type: ChallengeType.Boost,
    boostMultiplier: 2.0,
    challenge: {
      en: 'Public Dance Dare',
      nl: 'Openbare Dans Uitdaging',
      pt: 'Desafio de Dança Pública',
      zh: '公共舞蹈挑战',
      ro: 'Provocare de dans public',
      fr: 'Défi de danse publique',
    },
    description: {
      en: 'Perform a short dance (min 1 min) routine in a public area.',
      nl: 'Voer een korte dansroutine (min 1 min) uit op een openbare plek.',
      pt: 'Realize uma rotina de dança curta (min 1 min) em uma área pública.',
      zh: '在公共区域表演一段短舞蹈（最少1分钟）。',
      ro: 'Realizează o rutină de dans scurtă (min 1 min) într-o zonă publică.',
      fr: 'Effectuez une courte routine de danse (min 1 min) dans un lieu public.',
    },
    image:
      'https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExcDc4azA0OWtpOTMzNWdpNnl1djYxY2EwZ3hzcjh5YXNjdWJxNXdhOCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/l2JhL1AzTxORUTDlC/giphy.webp',
  },
  [NetherlandsPilotChallenge.WindmillWonder]: {
    key: NetherlandsPilotChallenge.WindmillWonder,
    type: ChallengeType.Normal,
    points: 10,
    challenge: {
      en: 'Windmill Wonder',
      nl: 'Molenwonder',
      pt: 'Maravilha do Moinho de Vento',
      zh: '风车奇观',
      ro: 'Minunea morii de vânt',
      fr: 'Merveille du moulin à vent',
    },
    description: {
      en: 'Take a selfie with a windmill.',
      nl: 'Maak een selfie met een molen.',
      pt: 'Tire uma selfie com um moinho de vento.',
      zh: '与风车合影。',
      ro: 'Fă o poză cu un moară de vânt.',
      fr: 'Prenez un selfie avec un moulin à vent.',
    },
    image:
      'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExeHYyZHcxeThxcGIyM3VwMzMwNTk0M2tqa2V3d2dtcXBtM3psMzU5NyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/WFlSw3IzjDy3k8FZRH/giphy.webp',
  },
  [NetherlandsPilotChallenge.SilentTrain]: {
    key: NetherlandsPilotChallenge.SilentTrain,
    type: ChallengeType.Curse,
    curseMultiplier: 0.5,
    challenge: {
      en: 'Silent Train',
      nl: 'Stille Trein',
      pt: 'Trem Silencioso',
      zh: '无声火车',
      ro: 'Trenul tăcut',
      fr: 'Train silencieux',
    },
    description: {
      en: 'Talk to someone in the silent compartment of a train.',
      nl: 'Praat met iemand in de stiltecoupe van een trein.',
      pt: 'Converse com alguém no compartimento silencioso de um trem.',
      zh: '与火车的无声车厢里的某人交谈。',
      ro: 'Discută cu cineva în compartimentul tăcut al unui tren.',
      fr: "Parlez à quelqu'un dans le compartiment silencieux d'un train.",
    },
    image:
      'https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExcWZuMXh1bHVuYnVqb3hrOXZ0b3VrOGU1Ymd2Z2hzZ2VxN285NW44bCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/wsAAfsY80yJDyGOZaE/giphy.webp',
  },
  [NetherlandsPilotChallenge.TheLettersToUtrecht]: {
    key: NetherlandsPilotChallenge.TheLettersToUtrecht,
    type: ChallengeType.Normal,
    points: 10,
    challenge: {
      en: 'The Letters of Utrecht',
      nl: 'De Letters van Utrecht',
      pt: 'As Letras de Utrecht',
      zh: '乌得勒支的字母',
      ro: 'Literele din Utrecht',
      fr: "Les lettres d'Utrecht",
    },
    description: {
      en: 'Find and read a segment of the "Letters of Utrecht" poem.',
      nl: 'Vind en lees een segment van het gedicht "De Letters van Utrecht".',
      pt: 'Encontre e leia um segmento do poema "As Letras de Utrecht".',
      zh: '找到并阅读《乌得勒支的字母》诗歌的一部分。',
      ro: 'Găsește și citește un segment din poezia "Literele din Utrecht".',
      fr: 'Trouvez et lisez un segment du poème "Les lettres d\'Utrecht".',
    },
    image:
      'https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExNWx0YXJ0MDQ4a3Jma3l3emp5ZWl0OG85NDlpcm1za2tiZ2ZmaTY2ZCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/NFA61GS9qKZ68/giphy.webp',
  },
  [NetherlandsPilotChallenge.StreetArtHunt]: {
    key: NetherlandsPilotChallenge.StreetArtHunt,
    type: ChallengeType.Normal,
    points: 10,
    challenge: {
      en: 'Street Art Hunt',
      nl: 'Straatkunstjacht',
      pt: 'Caça à Arte de Rua',
      zh: '寻找街头艺术',
      ro: 'Vânătoare de artă stradală',
      fr: "Chasse à l'art de rue",
    },
    description: {
      en: 'Find and photograph a piece of street art or graffiti.',
      nl: 'Vind en fotografeer een stuk straatkunst of graffiti.',
      pt: 'Encontre e fotografe uma peça de arte de rua ou grafite.',
      zh: '找到并拍摄一件街头艺术品或涂鸦。',
      ro: 'Găsește și fotografiază o piesă de artă stradală sau graffiti.',
      fr: "Trouvez et photographiez une œuvre d'art de rue ou un graffiti.",
    },
  },
  [NetherlandsPilotChallenge.LocalFlavor]: {
    key: NetherlandsPilotChallenge.LocalFlavor,
    type: ChallengeType.Normal,
    points: 20,
    challenge: {
      en: 'Local Flavor',
      nl: 'Lokale Smaak',
      pt: 'Sabor Local',
      zh: '当地风味',
      ro: 'Arome locale',
      fr: 'Saveur locale',
    },
    description: {
      en: 'Try a traditional Dutch food.',
      nl: 'Probeer een traditioneel Nederlands gerecht.',
      pt: 'Experimente uma comida tradicional holandesa.',
      zh: '尝试一种传统荷兰食物。',
      ro: 'Încearcă o mâncare tradițională olandeză.',
      fr: 'Essayez un plat traditionnel néerlandais.',
    },
    image:
      'https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExd2k4OTY5NGJubTJmbXJxbjI5N3dmODRvdGh3cnNseGd6bWMzcDc5dCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/7JsJNgBOIbAJumDNGk/giphy.webp',
  },
  [NetherlandsPilotChallenge.ComplimentALocal]: {
    key: NetherlandsPilotChallenge.ComplimentALocal,
    type: ChallengeType.Boost,
    boostMultiplier: 1.6,
    challenge: {
      en: 'Compliment a Local',
      nl: 'Complimenteer een Lokale',
      pt: 'Elogie um Local',
      zh: '赞美当地人',
      ro: 'Felicită un localnic',
      fr: 'Complimentez un local',
    },
    description: {
      en: 'Compliment a local person in Dutch.',
      nl: 'Complimenteer een lokale persoon in het Nederlands.',
      pt: 'Elogie uma pessoa local em holandês.',
      zh: '用荷兰语赞美当地人。',
      ro: 'Felicită o persoană locală în olandeză.',
      fr: 'Complimentez une personne locale en néerlandais.',
    },
  },
  [NetherlandsPilotChallenge.BullishAdventure]: {
    key: NetherlandsPilotChallenge.BullishAdventure,
    type: ChallengeType.Normal,
    points: 30,
    challenge: {
      en: 'Bullish Adventure',
      nl: 'Stierig Avontuur',
      pt: 'Aventura Taurina',
      zh: '公牛冒险',
      ro: 'Aventură taurină',
      fr: 'Aventure taurine',
    },
    description: {
      en: 'Seek out a prominent financial building in a major Dutch city, and take a group photo with a statue representing market success.',
      nl: 'Zoek een prominent financieel gebouw in een grote Nederlandse stad en maak een groepsfoto met een standbeeld dat marktsucces vertegenwoordigt.',
      pt: 'Procure um prédio financeiro proeminente em uma grande cidade holandesa e tire uma foto em grupo com uma estátua que represente o sucesso do mercado.',
      zh: '在荷兰主要城市中寻找一个著名的金融建筑，并与代表市场成功的雕像合影。',
    },
    image:
      'https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExYmV1MnQ1eHRwZ3g2cTQ3Yjh5c2ZicWV2azNva3pybmR6MXp0bWJ2diZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/HB4mYkjjFcvNm/giphy.webp',
  },
  [NetherlandsPilotChallenge.InternationalCourt]: {
    key: NetherlandsPilotChallenge.InternationalCourt,
    type: ChallengeType.Normal,
    points: 10,
    challenge: {
      en: 'International Court',
      nl: 'Internationaal Gerechtshof',
      pt: 'Tribunal Internacional',
      zh: '国际法院',
      ro: 'Curtea Internațională',
      fr: 'Cour internationale',
    },
    description: {
      en: 'Find the International Court of Justice building and take a picture outside.',
      nl: 'Vind het gebouw van het Internationaal Gerechtshof en maak een foto buiten.',
      pt: 'Encontre o prédio do Tribunal Internacional de Justiça e tire uma foto do lado de fora.',
      zh: '找到国际法院大楼并在外面拍照。',
      ro: 'Găsește clădirea Curții Internaționale de Justiție și fă o poză afară.',
      fr: "Trouvez le bâtiment de la Cour internationale de justice et prenez une photo à l'extérieur.",
    },
    image:
      'https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExaXhhazVlNXcxajB1bG14NHByaWsxcno5OHhvcGd3dmw1MW8wbHF2YyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/l5sNKozrhIXAvJnu0d/giphy.webp',
  },
  [NetherlandsPilotChallenge.WindmillSpin]: {
    key: NetherlandsPilotChallenge.WindmillSpin,
    type: ChallengeType.Curse,
    curseMultiplier: 0.7,
    challenge: {
      en: 'Windmill Spin',
      nl: 'Molen Draai',
      pt: 'Giro do Moinho de Vento',
      zh: '风车旋转',
      ro: 'Rotație de moară de vânt',
      fr: 'Rotation de moulin à vent',
    },
    description: {
      en: 'Spin around 10 times and then walk 10 meters in a straight line without falling.',
      nl: 'Draai 10 keer rond en loop dan 10 meter in een rechte lijn zonder te vallen.',
      pt: 'Dê 10 voltas e depois ande 10 metros em linha reta sem cair.',
      zh: '转10圈，然后直线走10米而不摔倒。',
      ro: 'Rotește-te de 10 ori și apoi mergi 10 metri în linie dreaptă fără să cazi.',
      fr: 'Faites 10 tours sur vous-même, puis marchez 10 mètres en ligne droite sans tomber.',
    },
    image:
      'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExd3d4bDRnaDU3eXFjajVyOGd6bWtnZjdsc2VscGx4MXV4N2I4Y2tvOSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/BXVUXTYCIKxbS4bSvp/giphy.webp',
  },
  [NetherlandsPilotChallenge.DomTowerSnapshot]: {
    key: NetherlandsPilotChallenge.DomTowerSnapshot,
    type: ChallengeType.Normal,
    points: 10,
    challenge: {
      en: 'Dom Tower Snapshot',
      nl: 'Domtoren Snapshot',
      pt: 'Foto da Torre Dom',
      zh: '多姆塔快照',
      ro: 'Fotografie cu Turnul Dom',
      fr: 'Photo de la tour Dom',
    },
    description: {
      en: 'Take a group selfie with the iconic Dom Tower in the background.',
      nl: 'Maak een groepsselfie met de iconische Domtoren op de achtergrond.',
      pt: 'Tire uma selfie em grupo com a icônica Torre Dom ao fundo.',
      zh: '与标志性的多姆塔背景合影。',
      ro: 'Fă o poză de grup cu iconica Turn Dom în fundal.',
      fr: 'Prenez un selfie de groupe avec la tour Dom emblématique en arrière-plan.',
    },
  },
  [NetherlandsPilotChallenge.ProvincesShowdown]: {
    key: NetherlandsPilotChallenge.ProvincesShowdown,
    type: ChallengeType.Normal,
    points: 40,
    challenge: {
      en: 'Provinces Showdown',
      nl: 'Provincies Showdown',
      pt: 'Confronto das Províncias',
      zh: '省份对决',
      ro: 'Confruntarea provinciilor',
      fr: 'Confrontation des provinces',
    },
    description: {
      en: 'Recite all the provinces of the Netherlands in front of the city hall of the capital of one of the provinces.',
      nl: 'Reciteer alle provincies van Nederland voor het stadhuis van de hoofdstad van een van de provincies.',
      pt: 'Recite todas as províncias dos Países Baixos em frente à prefeitura da capital de uma das províncias.',
      zh: '在荷兰一个省的省会市政厅前背诵荷兰所有省份。',
      ro: 'Recită toate provinciile Olandei în fața primăriei capitalei unei provincii.',
      fr: "Récitez toutes les provinces des Pays-Bas devant l'hôtel de ville de la capitale d'une des provinces.",
    },
    image:
      'https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExMDZhMGllNWpxN3ppZml6amhndXV4YzE4aTczeDZxNzN5OGphYWVwOCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/9dFvgd4ID6ne0/giphy.webp',
  },
  [NetherlandsPilotChallenge.FindMiffy]: {
    key: NetherlandsPilotChallenge.FindMiffy,
    type: ChallengeType.Normal,
    points: 10,
    challenge: {
      en: 'Find Miffy',
      nl: 'Vind Nijntje',
      pt: 'Encontre Miffy',
      zh: '找米菲',
      ro: 'Găsește-o pe Miffy',
      fr: 'Trouvez Miffy',
    },
    description: {
      en: 'Locate and take a picture with Miffy.',
      nl: 'Vind en maak een foto met Nijntje.',
      pt: 'Localize e tire uma foto com Miffy.',
      zh: '找到米菲并拍照。',
      ro: 'Localizează și fă o poză cu Miffy.',
      fr: 'Localisez et prenez une photo avec Miffy.',
    },
    image:
      'https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExanljczV3dTZvcTU1djY2MnBmZjl3ZDV5ZjgwZ3NveHNyeWNjdmk4aCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/FzXHX4g5EdXUeq4XPR/giphy.webp',
  },
  [NetherlandsPilotChallenge.PublicKaraoke]: {
    key: NetherlandsPilotChallenge.PublicKaraoke,
    type: ChallengeType.Curse,
    curseMultiplier: 0.3,
    challenge: {
      en: 'Public Karaoke',
      nl: 'Openbare Karaoke',
      pt: 'Karaokê Público',
      zh: '公共卡拉OK',
      ro: 'Karaoke public',
      fr: 'Karaoké public',
    },
    description: {
      en: 'Sing any song of your choice out loud in a public space, such as a park or square.',
      nl: 'Zing hardop een liedje naar keuze op een openbare plek, zoals een park of plein.',
      pt: 'Cante em voz alta qualquer música de sua escolha em um espaço público, como um parque ou praça.',
      zh: '在公共空间（如公园或广场）大声唱一首您选择的歌曲。',
      ro: 'Cântă orice melodie la alegerea ta cu voce tare într-un spațiu public, cum ar fi un parc sau o piață.',
      fr: 'Chantez à voix haute une chanson de votre choix dans un espace public, comme un parc ou une place.',
    },
    image:
      'https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExNGFmZ3diZWZtcHQ1a2hicXBwcm1namp6aTJ0NmM2czJsNjFvd3MwZyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/VCiM9RQ8R5T5ejkq4M/giphy.webp',
  },
  [NetherlandsPilotChallenge.JapaneseChristmas]: {
    key: NetherlandsPilotChallenge.JapaneseChristmas,
    type: ChallengeType.Normal,
    points: 30,
    challenge: {
      en: 'Japanese Christmas',
      nl: 'Japanse Kerst',
      pt: 'Natal Japonês',
      zh: '日本圣诞',
      ro: 'Crăciun japonez',
      fr: 'Noël japonais',
    },
    description: {
      en: "Find the establishment that plays a significant role in Japan's Christmas customs.",
      nl: 'Vind de instelling die een belangrijke rol speelt in de kerstgebruiken van Japan.',
      pt: 'Encontre o estabelecimento que desempenha um papel significativo nos costumes de Natal do Japão.',
      zh: '找到在日本圣诞习俗中起重要作用的机构。',
      ro: 'Găsește instituția care joacă un rol semnificativ în obiceiurile de Crăciun din Japonia.',
      fr: "Trouvez l'établissement qui joue un rôle significatif dans les coutumes de Noël du Japon.",
    },
    image:
      'https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExc2QzMnZzM3Fxd25wMnVqMnV1eXpmYTNmcXAyYmdhOTVnZXB5NHo2NSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/J4mrcRFUkFdAUXJNCl/giphy.webp',
  },
  [NetherlandsPilotChallenge.ProgrammingBirthplace]: {
    key: NetherlandsPilotChallenge.ProgrammingBirthplace,
    type: ChallengeType.Normal,
    points: 20,
    challenge: {
      en: 'Programming Birthplace',
      nl: 'Geboorteplaats Programmeren',
      pt: 'Local de Nascimento da Programação',
      zh: '编程诞生地',
      ro: 'Locul de naștere al programării',
      fr: 'Lieu de naissance de la programmation',
    },
    description: {
      en: 'Visit the birthplace of a famous Dutch computer programmer.',
      nl: 'Bezoek de geboorteplaats van een beroemde Nederlandse computerprogrammeur.',
      pt: 'Visite o local de nascimento de um famoso programador de computador holandês.',
      zh: '参观一位著名的荷兰计算机程序员的出生地。',
      ro: 'Vizitează locul de naștere al unui programator de calculator olandez faimos.',
      fr: "Visitez le lieu de naissance d'un célèbre programmeur informatique néerlandais.",
    },
    image:
      'https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExejN0dGtvOXM4eXJidGF1ODRwcXZqbWhsa2RzZWZuZ3RncnUwcjEwdiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/26tn33aiTi1jkl6H6/giphy.webp',
  },
  [NetherlandsPilotChallenge.RepurposedHistory]: {
    key: NetherlandsPilotChallenge.RepurposedHistory,
    type: ChallengeType.Normal,
    points: 20,
    challenge: {
      en: 'Repurposed History',
      nl: 'Herbestemde Geschiedenis',
      pt: 'História Reprocessada',
      zh: '历史再利用',
      ro: 'Istorie reutilizată',
      fr: 'Histoire réutilisée',
    },
    description: {
      en: 'Take a group photo with a church that has been repurposed for a modern use.',
      nl: 'Maak een groepsfoto met een kerk die is herbestemd voor een modern gebruik.',
      pt: 'Tire uma foto em grupo com uma igreja que foi reutilizada para um uso moderno.',
      zh: '与一座被重新用于现代用途的教堂合影。',
      ro: 'Fă o poză de grup cu o biserică care a fost reutilizată pentru un uz modern.',
      fr: 'Prenez une photo de groupe avec une église qui a été réutilisée à des fins modernes.',
    },
  },
  [NetherlandsPilotChallenge.Grachtenhuis]: {
    key: NetherlandsPilotChallenge.Grachtenhuis,
    type: ChallengeType.Normal,
    points: 10,
    challenge: {
      en: 'Dutch Canal House',
      nl: 'Nederlands Grachtenhuis',
      pt: 'Casa de Canal Holandesa',
      zh: '荷兰运河房屋',
      ro: 'Casa de canal olandeză',
      fr: 'Maison de canal néerlandaise',
    },
    description: {
      en: 'Take a group picture with a classic Dutch canal house in the background.',
      nl: 'Maak een groepsfoto met een klassiek Nederlands grachtenhuis op de achtergrond.',
      pt: 'Tire uma foto em grupo com uma casa de canal clássica holandesa ao fundo.',
      zh: '与背景中的经典荷兰运河房屋合影。',
      ro: 'Fă o poză de grup cu o casă de canal clasică olandeză în fundal.',
      fr: 'Prenez une photo de groupe avec une maison de canal classique néerlandaise en arrière-plan.',
    },
    image:
      'https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExeWNuMmYycjI3dzVoMzJuOHhhbWVvNGh2OTF0eDBxdGs1MmtuZnlnaiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/SwZTQndLPNQZ5i6OKM/giphy.webp',
  },
  [NetherlandsPilotChallenge.DutchMasters]: {
    key: NetherlandsPilotChallenge.DutchMasters,
    type: ChallengeType.Normal,
    points: 30,
    challenge: {
      en: 'Dutch Masters',
      nl: 'Nederlandse Meesters',
      pt: 'Mestres Holandeses',
      zh: '荷兰大师',
      ro: 'Maeștri olandezi',
      fr: 'Maîtres néerlandais',
    },
    description: {
      en: 'Find a piece of art by a Dutch Master',
      nl: 'Vind een kunstwerk van een Nederlandse Meester',
      pt: 'Encontre uma obra de arte de um Mestre Holandês',
      zh: '找到一件荷兰大师的作品',
      ro: 'Găsește o operă de artă a unui Maestru Olandez',
      fr: "Trouvez une œuvre d'un Maître néerlandais",
    },
  },
  [NetherlandsPilotChallenge.TwoCitiesOneName]: {
    key: NetherlandsPilotChallenge.TwoCitiesOneName,
    type: ChallengeType.Normal,
    points: 50,
    challenge: {
      en: 'Two Cities, One Name',
      nl: 'Twee Steden, Één Naam',
      pt: 'Duas Cidades, Um Nome',
      zh: '两个城市，一个名字',
      ro: 'Două orașe, un nume',
      fr: 'Deux villes, un nom',
    },
    description: {
      en: 'Visit two cities in the Netherlands that inspired U.S. city names.',
      nl: 'Bezoek twee steden in Nederland die Amerikaanse stadnamen hebben geïnspireerd.',
      pt: 'Visite duas cidades nos Países Baixos que inspiraram nomes de cidades dos EUA.',
      zh: '访问荷兰的两个城市，这两个城市启发了美国的城市名称。',
      ro: 'Vizitează două orașe din Olanda care au inspirat numele orașelor din SUA.',
      fr: 'Visitez deux villes aux Pays-Bas qui ont inspiré des noms de villes américaines.',
    },
    image:
      'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExZDFna242Y2h3bjRvemtqYnQ1MDBnMDB4YTVtOHNsZXV3ajlpMXlyciZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3oKGzEhwj4e1YihPZm/giphy.webp',
  },
  [NetherlandsPilotChallenge.GlassWalk]: {
    key: NetherlandsPilotChallenge.GlassWalk,
    type: ChallengeType.Normal,
    points: 40,
    challenge: {
      en: 'Glass Walk',
      nl: 'Glaswandeling',
      pt: 'Caminhada de Vidro',
      zh: '玻璃走道',
      ro: 'Mers pe sticlă',
      fr: 'Marche sur verre',
    },
    description: {
      en: 'Walk on the glass platform at Eusebius Church',
      nl: 'Loop op het glazen platform bij de Eusebiuskerk',
      pt: 'Caminhe na plataforma de vidro na Igreja de Eusebius',
      zh: '在欧塞比乌斯教堂的玻璃平台上行走',
      ro: 'Mergi pe platforma de sticlă de la Biserica Eusebius',
      fr: "Marchez sur la plateforme de verre de l'église Eusebius",
    },
    image:
      'https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExejcyMXR4Zmc3eXAwdjl0aHJqODdra2Z1bTJnb294bDQxdnd2cGJpdiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/RHOwWKH5OY7buuGHNi/giphy.webp',
  },
  [NetherlandsPilotChallenge.WoodenShoes]: {
    key: NetherlandsPilotChallenge.WoodenShoes,
    type: ChallengeType.Normal,
    points: 10,
    challenge: {
      en: 'Wooden Shoes',
      nl: 'Houten Schoenen',
      pt: 'Sapatos de Madeira',
      zh: '木鞋',
      ro: 'Pantofi de lemn',
      fr: 'Sabots',
    },
    description: {
      en: 'Find a traditional Dutch wooden shoe.',
      nl: 'Vind een traditionele Nederlandse houten schoen.',
      pt: 'Encontre um sapato de madeira tradicional holandês.',
      zh: '找到一双传统的荷兰木鞋。',
      ro: 'Găsește o pantof de lemn tradițional olandez.',
      fr: 'Trouvez un sabot traditionnel néerlandais.',
    },
  },
  [NetherlandsPilotChallenge.VOCHeritage]: {
    key: NetherlandsPilotChallenge.VOCHeritage,
    type: ChallengeType.Normal,
    points: 30,
    challenge: {
      en: 'VOC Heritage',
      nl: 'VOC Erfgoed',
      pt: 'Herança da VOC',
      zh: 'VOC遗产',
      ro: 'Moștenirea VOC',
      fr: 'Héritage de la VOC',
    },
    description: {
      en: 'Photograph a building or place connected to the Dutch East India Company (VOC)',
      nl: 'Fotografeer een gebouw of plek die verbonden is met de Verenigde Oost-Indische Compagnie (VOC)',
      pt: 'Fotografe um prédio ou local conectado à Companhia Holandesa das Índias Orientais (VOC)',
      zh: '拍摄与荷兰东印度公司（VOC）有关的建筑或地点',
      ro: 'Fotografiați un clădire sau un loc conectat la Compania Olandeză a Indiilor de Est (VOC)',
      fr: 'Photographiez un bâtiment ou un lieu lié à la Compagnie néerlandaise des Indes orientales (VOC)',
    },
  },
  [NetherlandsPilotChallenge.InsuranceLandmark]: {
    key: NetherlandsPilotChallenge.InsuranceLandmark,
    type: ChallengeType.Normal,
    points: 10,
    challenge: {
      en: 'Insurance Landmark',
      nl: 'Verzekeringslandmark',
      pt: 'Marco do Seguro',
      zh: '保险地标',
      ro: 'Punct de reper al asigurărilor',
      fr: "Repère de l'assurance",
    },
    description: {
      en: 'Find a building or office associated with a major Dutch insurance company.',
      nl: 'Vind een gebouw of kantoor dat is verbonden met een grote Nederlandse verzekeringsmaatschappij.',
      pt: 'Encontre um prédio ou escritório associado a uma grande empresa de seguros holandesa.',
      zh: '找到与一家荷兰大型保险公司相关的建筑或办公室。',
      ro: 'Găsește un clădire sau un birou asociat cu o mare companie de asigurări olandeză.',
      fr: 'Trouvez un bâtiment ou un bureau associé à une grande compagnie d’assurance néerlandaise.',
    },
  },
  [NetherlandsPilotChallenge.StatueSelfie]: {
    key: NetherlandsPilotChallenge.StatueSelfie,
    type: ChallengeType.Normal,
    challenge: {
      en: 'Statue Selfie',
      nl: 'Standbeeld Selfie',
      pt: 'Selfie de Estátua',
      zh: '雕像自拍',
      ro: 'Selfie cu statuie',
      fr: 'Selfie avec statue',
    },
    description: {
      en: 'Take a Selfie with a Statue of a Famous Dutch Artist or Writer',
      nl: 'Maak een selfie met een standbeeld van een beroemde Nederlandse kunstenaar of schrijver',
      pt: 'Tire uma selfie com uma estátua de um famoso artista ou escritor holandês',
      zh: '与一位著名荷兰艺术家或作家的雕像自拍',
      ro: 'Fă un selfie cu o statuie a unui artist sau scriitor olandez faimos',
      fr: 'Prenez un selfie avec une statue d’un célèbre artiste ou écrivain néerlandais',
    },
    points: 20,
  },
  [NetherlandsPilotChallenge.BinnenhofBeauty]: {
    key: NetherlandsPilotChallenge.BinnenhofBeauty,
    type: ChallengeType.Normal,
    points: 30,
    challenge: {
      en: 'Binnenhof Beauty',
      nl: 'Binnenhof Beauty',
      pt: 'Beleza do Binnenhof',
      zh: '国会大厦之美',
      ro: 'Frumusețea Binnenhof',
      fr: 'Beauté du Binnenhof',
    },
    description: {
      en: 'Photograph the Hofvijver with the Binnenhof in the Background',
      nl: 'Fotografeer de Hofvijver met het Binnenhof op de achtergrond',
      pt: 'Fotografe o Hofvijver com o Binnenhof ao fundo',
      zh: '拍摄背景为国会大厦的Hofvijver',
      ro: 'Fotografiați Hofvijver cu Binnenhof în fundal',
      fr: 'Photographiez le Hofvijver avec le Binnenhof en arrière-plan',
    },
  },
  [NetherlandsPilotChallenge.MarketBrowsing]: {
    key: NetherlandsPilotChallenge.MarketBrowsing,
    type: ChallengeType.Normal,
    challenge: {
      en: 'Market Browsing',
      nl: 'Marktbezoek',
      pt: 'Visita ao Mercado',
      zh: '逛市场',
      ro: 'Vizită la piață',
      fr: 'Visite du marché',
    },
    description: {
      en: 'Visit a Local Market and Take a Picture of a Unique Item',
      nl: 'Bezoek een lokale markt en maak een foto van een uniek item',
      pt: 'Visite um mercado local e tire uma foto de um item único',
      zh: '参观当地市场并拍摄一件独特的物品',
      ro: 'Vizitați o piață locală și fotografiați un element unic',
      fr: 'Visitez un marché local et prenez une photo d’un article unique',
    },
    points: 10,
  },
  [NetherlandsPilotChallenge.StatuePose]: {
    key: NetherlandsPilotChallenge.StatuePose,
    type: ChallengeType.Boost,
    boostMultiplier: 1.8,
    challenge: {
      en: 'Statue Pose',
      nl: 'Standbeeld Pose',
      pt: 'Pose de Estátua',
      zh: '雕像姿势',
      ro: 'Poziție de statuie',
      fr: 'Pose de statue',
    },
    description: {
      en: 'Strike a Pose with a random Statue for 1 minute',
      nl: 'Neem een pose aan met een willekeurig standbeeld gedurende 1 minuut',
      pt: 'Faça uma pose com uma estátua aleatória por 1 minuto',
      zh: '与随机雕像摆姿势1分钟',
      ro: 'Adoptați o poziție cu o statuie aleatoare timp de 1 minut',
      fr: 'Adoptez une pose avec une statue aléatoire pendant 1 minute',
    },
    image:
      'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExczRlcnV3NGd1cHhycnloM3k5Mm1yaWMwMWw1d3ZkaHhwMGIyZ2ZiYiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3o7WIJSvqw4gsE2iZ2/giphy.webp',
  },
  [NetherlandsPilotChallenge.Photobomb]: {
    key: NetherlandsPilotChallenge.Photobomb,
    type: ChallengeType.Boost,
    boostMultiplier: 1.5,
    challenge: {
      en: 'Photobomb',
      nl: 'Photobomb',
      pt: 'Photobomb',
      zh: 'Photobomb',
      ro: 'Photobomb',
      fr: 'Photobomb',
    },
    description: {
      en: 'Successfully photobomb a stranger’s photo at a tourist spot.',
      nl: 'Photobomb succesvol een foto van een vreemdeling op een toeristische plek.',
      pt: 'Photobomb com sucesso a foto de um estranho em um ponto turístico.',
      zh: '在旅游景点成功photobomb一个陌生人的照片。',
      ro: 'Photobomb cu succes fotografia unui străin la un punct turistic.',
      fr: 'Photobomb avec succès la photo d’un étranger sur un lieu touristique.',
    },
    image:
      'https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExZDdqMjQ0bmtsdTY1emFxOGJ1eml6ZWpuamdkeXh0dzRpYTJ2dzNkNyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/TrdOrVrCzYCiY/giphy.webp',
  },
  [NetherlandsPilotChallenge.GuessTheJob]: {
    key: NetherlandsPilotChallenge.GuessTheJob,
    type: ChallengeType.Curse,
    curseMultiplier: 0.3,
    challenge: {
      en: "Guess the Stranger's Job",
      nl: 'Raad het beroep van een vreemdeling',
      pt: 'Adivinhe o trabalho do estranho',
      zh: '猜陌生人的职业',
      ro: 'Ghicește meseria străinului',
      fr: 'Devine le métier de l’étranger',
    },
    description: {
      en: 'Approach a stranger and guess their job within three attempts.',
      nl: 'Benader een vreemdeling en raad hun beroep binnen drie pogingen.',
      pt: 'Aborde um estranho e adivinhe o trabalho dele em três tentativas.',
      zh: '接近陌生人并在三次尝试内猜出他们的职业。',
      ro: 'Apropie-te de un străin și ghicește-i meseria în trei încercări.',
      fr: 'Approchez un étranger et devinez son métier en trois tentatives.',
    },
  },
  [NetherlandsPilotChallenge.DutchChat]: {
    key: NetherlandsPilotChallenge.DutchChat,
    type: ChallengeType.Boost,
    boostMultiplier: 1.6,
    challenge: {
      en: 'Dutch Chat',
      nl: 'Nederlands Gesprek',
      pt: 'Conversa em Holandês',
      zh: '荷兰语聊天',
      ro: 'Chat în olandeză',
      fr: 'Discussion en néerlandais',
    },
    description: {
      en: 'Have a 1-minute conversation in Dutch with a native speaker without using any English.',
      nl: 'Heb een gesprek van 1 minuut in het Nederlands met een moedertaalspreker zonder Engels te gebruiken.',
      pt: 'Tenha uma conversa de 1 minuto em holandês com um falante nativo sem usar inglês.',
      zh: '与荷兰母语人士进行一分钟的荷兰语对话，不使用任何英语。',
      ro: 'Aveți o conversație de 1 minut în olandeză cu un vorbitor nativ fără a folosi engleza.',
      fr: 'Avoir une conversation d’une minute en néerlandais avec un locuteur natif sans utiliser l’anglais.',
    },
    image:
      'https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExZnp5NGZkMWp6bHJ5cTR0YTZwOHpsNmt4cXgzdGducGF6OTNoNzRuNiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/U5OkqHaFTnznGkKGp5/giphy.webp',
  },
  [NetherlandsPilotChallenge.Paparazzi]: {
    key: NetherlandsPilotChallenge.Paparazzi,
    type: ChallengeType.Boost,
    boostMultiplier: 1.5,
    challenge: {
      en: 'Paparazzi',
      nl: 'Paparazzi',
      pt: 'Paparazzi',
      zh: '狗仔队',
      ro: 'Paparazzi',
      fr: 'Paparazzi',
    },
    description: {
      en: 'Take a group photo with a celebrity.',
      nl: 'Maak een groepsfoto met een beroemdheid.',
      pt: 'Tire uma foto em grupo com uma celebridade.',
      zh: '与名人合影。',
      ro: 'Fă o poză de grup cu o celebritate.',
      fr: 'Prenez une photo de groupe avec une célébrité.',
    },
    image:
      'https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExZTJka2VkcGltNWc2dHl4bGlkZTZibTFkbGtrcmpzeGx5bmJydzluZiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/8YQWt6TpuFIJO/200.webp',
  },
  [NetherlandsPilotChallenge.RoyalConnection]: {
    key: NetherlandsPilotChallenge.RoyalConnection,
    type: ChallengeType.Normal,
    points: 10,
    challenge: {
      en: 'Royal Connection',
      nl: 'Koninklijke Connectie',
      pt: 'Conexão Real',
      zh: '皇家联系',
      ro: 'Conexiune regală',
      fr: 'Connexion royale',
    },
    description: {
      en: 'Find and photograph a building or landmark associated with Dutch royalty, such as a palace or royal residence.',
      nl: 'Vind en fotografeer een gebouw of monument dat is verbonden met de Nederlandse koninklijke familie, zoals een paleis of koninklijke residentie.',
      pt: 'Encontre e fotografe um prédio ou marco associado à realeza holandesa, como um palácio ou residência real.',
      zh: '找到并拍摄与荷兰皇室有关的建筑或地标，例如宫殿或皇家住所。',
      ro: 'Găsește și fotografiază o clădire sau un punct de referință asociat cu familia regală olandeză, cum ar fi un palat sau o reședință regală.',
      fr: 'Trouvez et photographiez un bâtiment ou un monument associé à la royauté néerlandaise, comme un palais ou une résidence royale.',
    },
  },
  [NetherlandsPilotChallenge.PetsAreTheBest]: {
    key: NetherlandsPilotChallenge.PetsAreTheBest,
    type: ChallengeType.Normal,
    points: 20,
    challenge: {
      en: 'Pets Are The Best',
      nl: 'Huisdieren Zijn De Beste',
      pt: 'Animais de Estimação São os Melhores',
      zh: '宠物是最棒的',
      ro: 'Animalele de companie sunt cele mai bune',
      fr: 'Les animaux de compagnie sont les meilleurs',
    },
    description: {
      en: 'Take a picture with a pet in a public place.',
      nl: 'Maak een foto met een huisdier op een openbare plek.',
      pt: 'Tire uma foto com um animal de estimação em um local público.',
      zh: '在公共场所与宠物合影。',
      ro: 'Fă o poză cu un animal de companie într-un loc public.',
      fr: 'Prenez une photo avec un animal de compagnie dans un lieu public.',
    },
    image:
      'https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExdHZicmNxNXpyNWg0MGQ0a2thanhpb2s1YmIwZGdobHBhMGxyaTdmayZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/moMd5EntFglTG/giphy.webp',
  },
  [NetherlandsPilotChallenge.CityOfBikes]: {
    key: NetherlandsPilotChallenge.CityOfBikes,
    type: ChallengeType.Normal,
    points: 10,
    challenge: {
      en: 'City of Bikes',
      nl: 'Fietsstad',
      pt: 'Cidade das Bicicletas',
      zh: '自行车之城',
      ro: 'Orașul bicicletelor',
      fr: 'Ville des vélos',
    },
    description: {
      en: 'Photograph a street or area filled with atleast a 50 bicycles.',
      nl: 'Fotografeer een straat of gebied gevuld met minstens 50 fietsen.',
      pt: 'Fotografe uma rua ou área cheia de pelo menos 50 bicicletas.',
      zh: '拍摄一条或一个区域至少有50辆自行车。',
      ro: 'Fotografiați o stradă sau o zonă plină cu cel puțin 50 de biciclete.',
      fr: 'Photographiez une rue ou une zone remplie d’au moins 50 vélos.',
    },
    image:
      'https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExcmQ3NjFkaG9wd2JhbXlkMWlnZnd3c3ExaDVsZGF5OHVnZzhjcm52dyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/BKgUB7IapKg3CT3yxp/giphy.webp',
  },
  [NetherlandsPilotChallenge.AlphabetCity]: {
    key: NetherlandsPilotChallenge.AlphabetCity,
    type: ChallengeType.Normal,
    points: 20,
    challenge: {
      en: 'Alphabet City',
      nl: 'Alfabetstad',
      pt: 'Cidade do Alfabeto',
      zh: '字母城市',
      ro: 'Orașul alfabetului',
      fr: 'Ville de l’alphabet',
    },
    description: {
      en: 'Find three different places or landmarks whose names start with consecutive letters of the Dutch alphabet (e.g., A, B, C). Take a photo of each.',
      nl: 'Vind drie verschillende plaatsen of bezienswaardigheden waarvan de namen beginnen met opeenvolgende letters van het Nederlandse alfabet (bijv. A, B, C). Maak van elk een foto.',
      pt: 'Encontre três lugares ou marcos diferentes cujos nomes comecem com letras consecutivas do alfabeto holandês (por exemplo, A, B, C). Tire uma foto de cada um.',
      zh: '找到三个不同的地方或地标，其名称以荷兰字母表的连续字母开头（例如，A，B，C）。 每个拍照。',
      ro: 'Găsiți trei locuri sau puncte de referință diferite ale căror nume încep cu litere consecutive ale alfabetului olandez (de exemplu, A, B, C). Faceți o fotografie cu fiecare.',
      fr: 'Trouvez trois endroits ou monuments différents dont les noms commencent par des lettres consécutives de l’alphabet néerlandais (par exemple, A, B, C). Prenez une photo de chacun.',
    },
  },
}
